import   { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import useFormErrorHighlight from '../../../hooks/useFormErrorHighlight'
import axios from 'axios';
import { Helmet } from 'react-helmet-async';


     // Default values
     const defaultDistrict     = 'District 2';
     const defaultMunicipality = 'Quezon City';
     const defaultBarangay     = 'Bahay Toro';


const ClientBeneficiaryForm = ({ personType, onChange, div_to_scroll_index, errorMessage, title, handleDelete }) => {

 
  

 
    const [divVoterVisibility, setDivVoterVisibility] = useState(false);
    const districtFieldName = `${personType}_district`;
    const districtErrorMessage = errorMessage && errorMessage.errors && errorMessage.errors[districtFieldName];

    const getFieldErrorMessage = useFormErrorHighlight(errorMessage);

    const [selectedDate, setSelectedDate] = useState(null);

    const initialFormData = {
        [`${personType}_fullname`]      : "",
        [`${personType}_isVoter`]       : "",
        [`${personType}_voter_id`]      : "",
        [`${personType}_email`]         : "",
        [`${personType}_contact`]       : "",
        [`${personType}_gender`]        : "",
        [`${personType}_birthdate`]     : "",
        [`${personType}_address`]       : "",
        [`${personType}_district`]      : defaultDistrict,
        [`${personType}_municipality`]  : defaultMunicipality,
        [`${personType}_barangay`]      : defaultBarangay,
        [`${personType}_sitio`]         : "",
        [`${personType}_family_id`]     : "",
        [`${personType}_family_role`]   : "",
        [`${personType}_civil_status`]  : "",
        [`${personType}_place_of_birth`]: "",
      };
    const [formData, setFormData] = useState(initialFormData);


    // Update local state and notify parent about changes
    const handleChange = (e) => {
        
        const { name, value } = e.target;

        const isDistrict     = name.endsWith('_district');
        const isMunicipality = name.endsWith('_municipality');
        const isBarangay     = name.endsWith('_barangay');
        
        if (isDistrict) {
            handleDistrictChange(value);
        } else if (isMunicipality) {
            handleMunicipalityChange(value);
        } else if (isBarangay) {
            handleBarangayChange(value);
        }

        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));

        console.log(name, value);
        // Notify parent about changes
        onChange(formData);
    };

    const handleDateChange = (date) => {
        setSelectedDate(date);
      };
    

      const updateFormData = (date) => {
        const updatedFormData = {
          ...formData,
          [`${personType}_birthdate`]: date ? date.toISOString().split('T')[0] : "",
        };
        setFormData(updatedFormData);
      };

    useEffect(() => {
        onChange(formData);
    }, [formData]);


 

    const [data, setData]             = useState([]);
    const [count, setCount]           = useState(0);
    const [searchTerm, setSearchTerm] = useState('')

    useEffect(() => {

        if (searchTerm !== "") {
            const delayDebounceFn = setTimeout(async () => {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/voters/?search=${searchTerm}`);
                setData(response.data.results);
                setCount(response.data.count)
                setDivVoterVisibility(true);
                console.log(response.data);
            }, 750)

            return () => clearTimeout(delayDebounceFn)
        }
        else {
            setData(null);
        }


    }, [searchTerm])


    const colors = ['danger', 'primary', 'success', 'info', 'warning'];




    // FOR LOCATION: DISTRICT , MUNICIPALITY , BARANGAY

    const [cachedData, setCachedData] = useState([]);
    useEffect(() => {
        const cachedDataString = localStorage.getItem('cachedData');
        if (cachedDataString) {
            const parsedCachedData = JSON.parse(cachedDataString);
            setCachedData(parsedCachedData);
        }
    }, []);


    const [districtList, setDistrictList] = useState([]);
    const [district, setDistrict]         = useState(defaultDistrict);

    const [municipalityList, setMunicipalityList] = useState([]);
    const [municipality, setMunicipality]         = useState(defaultMunicipality);

    const [barangayList, setBarangayList] = useState([]);
    const [barangay, setBarangay]         = useState(defaultBarangay);


 



    useEffect(() => {
        // GETTING ALL DISTRICTS ONLY
        const uniqueDistricts = [...new Set(cachedData.map(location => location.location_district))];

        const sortedDistricts = uniqueDistricts.sort((a, b) => {
            const numA = parseInt(a.match(/\d+/)[0]);
            const numB = parseInt(b.match(/\d+/)[0]);
            return numA - numB;
        });

        setDistrictList(sortedDistricts);
        setIsDistrictReady(true);


    }, [cachedData]);



    // const [filteredData, setFilteredData] = useState([]);

    // useEffect(() => {
    //     if (district && municipality) {
    //         const filteredLocations = cachedData.filter(location =>
    //             location.location_district === district && location.location_municipality === municipality
    //         );
    //         setFilteredData(filteredLocations);
    //     }
    // }, [district, municipality]);



    {/* THIS PART IS FOR DEFAULT VALUE SELECTION */}
    const [isDistrictReady, setIsDistrictReady] = useState(false);
    const [isMunicipalityReady, setIsMunicipalityReady] = useState(false);

   useEffect(() => {
        if (isDistrictReady) {
            handleDistrictChange(defaultDistrict);
        }
    }, [isDistrictReady]);

    useEffect(() => {
        if (isDistrictReady && district === defaultDistrict) {
            handleMunicipalityChange(defaultMunicipality);
        }
    }, [municipalityList]);

    useEffect(() => {
        if (isMunicipalityReady && municipality === defaultMunicipality) {
            setBarangay(defaultBarangay);
        }
    }, [barangayList]);


    const handleDistrictChange = (selectedDistrict) => {
        setMunicipalityList([]);
        setBarangayList([]);
        setMunicipality('');
        setBarangay('');

        setDistrict(selectedDistrict);

        const municipalities = cachedData
            .filter(location => location.location_district === selectedDistrict)
            .map(location => location.location_municipality)
            .sort((a, b) => a.localeCompare(b));

        const uniqueMunicipalities = [...new Set(municipalities)];
        setMunicipalityList(uniqueMunicipalities);
        setIsMunicipalityReady(true);

        if (selectedDistrict === defaultDistrict) {
            setMunicipality(defaultMunicipality);
        }
    };

    const handleMunicipalityChange = (selectedMunicipality) => {
        setMunicipality(selectedMunicipality);

        const barangays = cachedData
            .filter(location => location.location_district === district && location.location_municipality === selectedMunicipality)
            .map(location => location.location_barangay)
            .sort((a, b) => a.localeCompare(b));

        const uniqueBarangays = [...new Set(barangays)];
        setBarangayList(uniqueBarangays);

        if (selectedMunicipality === defaultMunicipality) {
            setBarangay(defaultBarangay);
        }
    };

    const handleBarangayChange = (selectedBarangay) => {
        setBarangay(selectedBarangay);
    };


    const handleRowClick = (rowData) => {
        setDivVoterVisibility(false)
        // Update form data with the clicked row's data

        setMunicipalityList([]);
        setBarangayList([]);

        setMunicipality('');
        setBarangay('');


        setDistrict(rowData.voter_district);
        setMunicipality(rowData.voter_municipality);
        setBarangay(rowData.voter_barangay);


        setFormData({
            ...formData,
            [`${personType}_voter_id`]                     : rowData.voter_id ?? "",
            [`${personType}_fullname`]                     : rowData.voter_name ?? "",
            [`${personType}_address`]                      : rowData.voter_address ?? "",
            [`${personType}_gender`]                       : (rowData.voter_gender ?? "").toLowerCase(),
            [`${personType}_birthdate`]                    : rowData.voter_birthday ?? "",
            [`${personType}_district`]                     : rowData.voter_district ?? "",
            [`${personType}_municipality`]                 : rowData.voter_municipality ?? "",
            [`${personType}_barangay`]                     : rowData.voter_barangay ?? "",
            [`${personType}_sitio`]                        : rowData.voter_sitio ?? "",
            [`${personType}_contact`]                      : rowData.voter_contact ?? "",
            [`${personType}_email`]                        : rowData.voter_fb_email ?? "",
            [`${personType}_isVoter`]                      : rowData.isVoter ?? "",
            [`${personType}_household_id`]                 : rowData.voter_household_id ?? "",
            [`${personType}_household_role`]               : rowData.voter_household_role ?? "",
            [`${personType}_government_position`]          : rowData.voter_government_position ?? "",
            [`${personType}_voter_cluster_number`]         : rowData.voter_cluster_number ?? "",
            [`${personType}_voter_clustered_polling_place`]: rowData.voter_clustered_polling_place ?? "",
            [`${personType}_voter_clustered_precinct`]     : rowData.voter_clustered_precinct ?? "",
            [`${personType}_voter_id_status`]              : rowData.voter_id_status ?? "",
            [`${personType}_voter_image_path`]             : rowData.voter_image_path ?? "",
            [`${personType}_voter_leader`]                 : rowData.voter_leader ?? "",
            [`${personType}_voter_org`]                    : rowData.voter_org ?? "",
            [`${personType}_voter_org_2`]                  : rowData.voter_org_2 ?? "",
            [`${personType}_voter_poll_watcher_workers`]   : rowData.voter_poll_watcher_workers ?? "",
            [`${personType}_voter_religion`]               : rowData.voter_religion ?? "",
            [`${personType}_voter_sector`]                 : rowData.voter_sector ?? "",
            [`${personType}_voter_status`]                 : rowData.voter_status ?? "",
            [`${personType}_voter_structure_code`]         : rowData.voter_structure_code ?? "",
            [`${personType}_voter_structure_name`]         : rowData.voter_structure_name ?? "",
            [`${personType}_voter_vital_status`]           : rowData.voter_vital_status ?? "",
            [`${personType}_voter_working_status`]         : rowData.voter_working_status ?? "",

        });

        const birthdate = new Date(rowData.voter_birthday) ?? "";
        setSelectedDate(birthdate);
        

        handleDistrictChange(rowData.voter_district);
        handleMunicipalityChange(rowData.voter_municipality);
        handleBarangayChange(rowData.voter_barangay);

    };

    useEffect(() => {
        handleDistrictChange(district);


        if (municipalityList.includes(municipality)) {
            // setMunicipality(newMunicipalityList[0] || '');
            // console.log(municipality);
        }

    }, [district]);

    useEffect(() => {
        handleMunicipalityChange(municipality);
    }, [municipality]);

    useEffect(() => {
        // Handle barangay change
        handleBarangayChange(barangay);
    }, [barangay]);

 

    const resetForm = () => {
        setFormData(initialFormData);

        handleDistrictChange('');
        handleMunicipalityChange('');
        handleBarangayChange('');
      };
    
      
     


      
      


    return (
        <>
            <div id={`div_to_scroll_${div_to_scroll_index}`} className="card mb-4"  >
                <div className="card-header d-flex justify-content-between mx-2">
                    <h5 className="card-title m-0 text-info">{title.toUpperCase()} DETAILS</h5>

                    {handleDelete && ( // Check if handleDelete is provided
                        <button onClick={handleDelete} className="btn btn-danger">Delete Member</button>
                    )}
                </div>
                <div className="card-body">



                    <div className="row mb-3 g-3">





                        <div className="col-12">
                           

                            <label className="form-label text-info mb-0" htmlFor={`${personType}_search`}>Search Voter</label>
                            <div className="input-group">
                                <input type="search" className="form-control" id={`${personType}_search`} name={`${personType}_search`} onChange={(e) => setSearchTerm(e.target.value)} placeholder="Voter name..." />
                                <button className="btn btn-outline-primary" type="button" id="button-addon2" onClick={resetForm}>Clear Form</button>
                            </div>


                            <div className={ divVoterVisibility ? 'd-block':'d-none' }>

                                {data && count == 0 ?
                                    <div className="list-group mt-1">
                                        <li className="list-group-item list-group-item-action d-flex justify-content-between">
                                            <div className="li-wrapper d-flex justify-content-start align-items-center">
                                                <div className="list-content text-info">
                                                    NO DATA FOUND
                                                </div>
                                            </div>
                                        </li>
                                    </div>
                                    :
                                    data && data.map((row, index) => (
                                        <div key={index} className="list-group mt-1">
                                            <button type="button" className="list-group-item list-group-item-action d-flex justify-content-between" onClick={() => handleRowClick(row)}>

                                                <table className='w-100'>
                                                    <tbody>
                                                        <tr>
                                                            <td width="250">
                                                                <div className="li-wrapper d-flex  align-items-center">

                                                                    {row.voter_image_path ?
                                                                        <img src={row.voter_image_path} alt="User Image" className="rounded-circle me-3 w-px-50"></img>
                                                                        :
                                                                        <div className="avatar avatar-sm me-3">
                                                                            <span className={`avatar-initial rounded-circle bg-label-${colors[index % colors.length]}`}>{row.voter_name[0].toUpperCase()}</span>
                                                                        </div>
                                                                    }

                                                                    <div className="list-content">
                                                                        <h6 className="mb-1">{row.voter_name?.toUpperCase()}</h6>
                                                                        <small className="text-muted">Birthday: {row.voter_birthday}</small>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td width="150">
                                                                <div className="list-content  text-center ">
                                                                    <h6 className="mb-1">{row.voter_municipality}</h6>
                                                                    <small className="text-muted">Municipality</small>
                                                                </div>
                                                            </td>
                                                            <td width="150">
                                                                <div className="list-content  text-center ">
                                                                    <h6 className="mb-1">{row.voter_barangay}</h6>
                                                                    <small className="text-muted">Barangay</small>
                                                                </div>
                                                            </td>
                                                            <td width="150">
                                                                <div className="list-content  text-center ">
                                                                    <h6 className="mb-1">{row.voter_precinct_no}</h6>
                                                                    <small className="text-muted">Precinct</small>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>



                                            </button>
                                        </div>
                                    ))}

                            </div>


                        </div>


                    </div>

                    <div className="row mb-3 g-3">
                        <div className="col-12">
                            <div className="divider divider-primary">
                                <div className="divider-text">OR</div>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-3 g-3" >
                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_fullname`}>Enter Fullname</label>
                            <input type="text" className="form-control" id={`${personType}_fullname`} name={`${personType}_fullname`} value={formData[`${personType}_fullname`]} onChange={handleChange}
                                placeholder="Ex. Dela Cruz Sr, Juan Agapito" aria-label="settings Details"
                                style={{ borderColor: getFieldErrorMessage(`${personType}_fullname`) }} />
                        </div>
                        <div className="col-12 col-md-6 d-none">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_voter_id`}>CVL ID</label>
                            <input type="text" className="form-control" id={`${personType}_voter_id`} name={`${personType}_voter_id`} value={formData[`${personType}_voter_id`]} onChange={handleChange} />
                        </div>
                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_email`}>Email</label>
                            <input type="email" className="form-control" id={`${personType}_email`} name={`${personType}_email`} value={formData[`${personType}_email`]} onChange={handleChange} placeholder="john@gmail.com" aria-label="email" />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_contact`}>Contact</label>
                            <input type="number" id={`${personType}_contact`} name={`${personType}_contact`} value={formData[`${personType}_contact`]} onChange={handleChange} className="form-control" placeholder="Contact" min={0} max={999999} />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_gender`}>Gender</label>
                            <select id={`${personType}_gender`} name={`${personType}_gender`} value={formData[`${personType}_gender`]} onChange={handleChange} className="select2 form-select" data-placeholder="Gender">
                                <option >Select Gender</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                            </select>
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_birthdate`} >Birthday</label>

                            <DatePicker
                                id={`${personType}_birthdate`}
                                name={`${personType}_birthdate`}
                                className="form-control flatpickr-input active"
                                placeholderText="YYYY-MM-DD"
                                selected={selectedDate}
                                onChange={(date) => {
                                    handleDateChange(date);
                                    updateFormData(date);
                                }}
                                dateFormat="yyyy-MM-dd"
                                // value={formData[`${personType}_birthdate`]}
                            />
                        </div>



                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_address`}>Address</label>
                            <input type="text" className="form-control" id={`${personType}_address`} value={formData[`${personType}_address`]} onChange={handleChange} name={`${personType}_address`} placeholder="Address" aria-label="email" />
                        </div>


                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_district`}>District</label>
                            <select id={`${personType}_district`} name={`${personType}_district`} value={district} onChange={handleChange} className="select2 form-select" data-placeholder="District" style={{ borderColor: districtErrorMessage ? 'red' : '' }}>
                                <option value="">Select District</option>
                                {districtList.map((district, index) => (
                                    <option key={index} value={district}>{district}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_municipality`}>Municipality</label>
                            <select id={`${personType}_municipality`} name={`${personType}_municipality`} value={municipality} onChange={handleChange} className="select2 form-select" data-placeholder="Municipality">
                                <option value="">Select Municipality</option>
                                {municipalityList.map((municipality, index) => (
                                    <option key={index} value={municipality}>{municipality}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_barangay`}>Barangay</label>
                            <select id={`${personType}_barangay`} name={`${personType}_barangay`} value={barangay} onChange={handleChange} className="select2 form-select" data-placeholder="Barangay">
                                <option value="">Select Barangay</option>
                                {barangayList.map((barangay, index) => (
                                    <option key={index} value={barangay}>{barangay}</option>
                                ))}
                            </select>
                        </div>


                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_sitio`}>Sitio</label>
                            <input type="text" className="form-control" id={`${personType}_sitio`} value={formData[`${personType}_sitio`]} onChange={handleChange} name={`${personType}_sitio`} placeholder="Sitio" />
                        </div>

                      
                        <div className="col-12 col-md-6 d-none">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_family_id`}>Family ID</label>
                            <input type="text" className="form-control" id={`${personType}_family_id`} name={`${personType}_family_id`} value={formData[`${personType}_family_id`]} onChange={handleChange} placeholder="Family ID (optional)" />
                        </div>

                        <div className="col-12 col-md-6 d-none">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_family_role`}>Role in the Family</label>
                            <select id={`${personType}_family_role`} name={`${personType}_family_role`} value={formData[`${personType}_family_role`]} onChange={handleChange} className="select2 form-select" data-placeholder="Role">
                                <option value=""></option>
                                <option value="Head">Head</option>
                                <option value="Father">Father</option>
                                <option value="Mother">Mother</option>
                                <option value="Child">Child</option>
                            </select>
                        </div>

                        <div className="col-12 col-md-6 d-none">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_family_id`}>Family ID</label>
                            <input type="text" className="form-control" id={`${personType}_family_id`} name={`${personType}_family_id`} value={formData[`${personType}_family_id`]} onChange={handleChange} placeholder="Family ID (optional)" />
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_civil_status`}>Civil Status</label>
                            <select id={`${personType}_civil_status`} name={`${personType}_civil_status`} value={formData[`${personType}_civil_status`]} onChange={handleChange} className="select2 form-select" data-placeholder="Civil Status">
                                <option value="">Select Civil Status</option>
                                <option value="Single">Single</option>
                                <option value="Married">Married</option>
                                <option value="Separated">Separated</option>
                                <option value="Widowed">Widowed</option>
                            </select>
                        </div>

                        <div className="col-12 col-md-6">
                            <label className="form-label text-info mb-0" htmlFor={`${personType}_place_of_birth`}>Place of Birth</label>
                            <input type="text" className="form-control" id={`${personType}_place_of_birth`} name={`${personType}_place_of_birth`} value={formData[`${personType}_place_of_birth`]} onChange={handleChange} placeholder="Place of Birth" />
                        </div>




                    </div>

                </div>
            </div>


        </>
    );
}

export default ClientBeneficiaryForm;
